import {t} from '../../common/getTranslations';
import {FreeSeriesStaticLandingPageVo} from '../../common/shared/api/karina/vo/page/FreeSeriesStaticLandingPageVo.interface';
import {CategoryTypeVo} from '../../common/shared/api/nicolas/vo/enums/CategoryTypeVo.enum';
import {
  GroupType,
  LayoutType,
  Maybe,
  SectionType,
  StaticLandingFreeSeriesParamInput,
  StaticLandingFreeSeriesSection,
  StaticLandingType,
  User,
} from '../generated/types';
import {createCardViewItem} from './CardViewItem';
import {createPromotionBannerItem} from './PromotionBannerItem';
import {createSortOption} from './SortOption';
import {createStaticLandingFreeSeriesSectionParam} from './StaticLandingFreeSeriesSectionParam';

export function createStaticLandingFreeSeriesSection(
  userInfo: Maybe<User>,
  {
    sectionId,
    freeSeriesStaticLandingPageVo: vo,
    input,
    type = LayoutType.Landing,
  }: {
    sectionId?: string;
    freeSeriesStaticLandingPageVo: FreeSeriesStaticLandingPageVo;
    input: StaticLandingFreeSeriesParamInput;
    type?: LayoutType;
  }
): StaticLandingFreeSeriesSection {
  const param = createStaticLandingFreeSeriesSectionParam(vo, input);
  return {
    id:
      sectionId ||
      `static-landing-${StaticLandingType.FreeSeries}-section-${type}-${
        param.categoryUid
      }-${param.tab?.param}${input.screenUid ? `-${input.screenUid}` : ''}`,
    type: SectionType.LandingFreeSeries,
    groups: [
      {
        id: `static-landing-${StaticLandingType.FreeSeries}-group-${
          param.categoryUid
        }-${param.tab?.param}${input.screenUid ? `-${input.screenUid}` : ''}`,
        type: GroupType.CardView,
        items:
          vo.list?.map(item =>
            createCardViewItem(userInfo, {
              itemSeriesDto: item,
            })
          ) || [],
      },
    ],
    tabList:
      vo.tab_opt_list?.map(opt => createSortOption({filterOptionVo: opt})) ||
      [],
    isEnd: vo.is_end || false,
    totalCount: vo.total_count || 0,
    title:
      input.categoryUid === CategoryTypeVo.Cartoon
        ? t('landing_category_webtoon')
        : input.categoryUid === CategoryTypeVo.Novel
          ? t('landing_category_novel')
          : undefined,
    param,
    promotionBanner: vo.section_promotion_banner
      ? createPromotionBannerItem(vo.section_promotion_banner)
      : undefined,
  };
}
